export const benefitsItems: { title: string, content: string }[] = [
  { title: 'benefit-1.title', content: 'benefit-1.content' },
  { title: 'benefit-2.title', content: 'benefit-2.content' },
  { title: 'benefit-3.title', content: 'benefit-3.content' },
  { title: 'benefit-4.title', content: 'benefit-4.content' },
  { title: 'benefit-5.title', content: 'benefit-5.content' },
  { title: 'benefit-6.title', content: 'benefit-6.content' },
];
